var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJackpot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d4e1f4;}.cls-2{fill:#40f4d2;}.cls-3{fill:#14e3ba;}.cls-4{fill:#6a52fd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Daily Jackpot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264,231H124V141H94V261H304V231Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79,410V369H49V299l45-50V19A40.13,40.13,0,0,1,95.26,9H94A40,40,0,0,0,54,49V279L9,329v70H39v41H359V410Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M389,209.5a9,9,0,0,1-9-9v-85a9,9,0,0,1,18,0v85a9,9,0,0,1-9,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M403.5,124.5h-29a9,9,0,0,1,0-18h29a9,9,0,0,1,0,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164,270H94a9,9,0,0,1-9-9V141a9,9,0,0,1,9-9h70a9,9,0,0,1,9,9V261a9,9,0,0,1-9,9Zm-61-18h52V150H103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304,270H234a9,9,0,0,1-9-9V141a9,9,0,0,1,9-9h70a9,9,0,0,1,9,9V261a9,9,0,0,1-9,9Zm-61-18h52V150H243Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M284,42H114A29,29,0,0,0,85,71v30a9,9,0,0,0,9,9H304a9,9,0,0,0,9-9V71a29,29,0,0,0-29-29Zm11,50H103V71a11,11,0,0,1,11-11H284a11,11,0,0,1,11,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M414,194.5H353V49A49.05,49.05,0,0,0,304,0H94A49.05,49.05,0,0,0,45,49V275.55L2.31,323A9,9,0,0,0,0,329v70a9,9,0,0,0,9,9H30v32a9,9,0,0,0,9,9H359a9,9,0,0,0,9-9V408h21a9,9,0,0,0,9-9V329a9,9,0,0,0-2.31-6L353,275.55V242.5h61a9,9,0,0,0,9-9v-30a9,9,0,0,0-9-9ZM350,431H48V408H350Zm30-98.55V390H18V332.45L60.69,285A9,9,0,0,0,63,279V49A31,31,0,0,1,94,18H304a31,31,0,0,1,31,31V279a9,9,0,0,0,2.31,6ZM405,224.5H353v-12h52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M234,270H164a9,9,0,0,1-9-9V141a9,9,0,0,1,9-9h70a9,9,0,0,1,9,9V261a9,9,0,0,1-9,9Zm-61-18h52V150H173Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpot);
export default __webpack_public_path__ + "static/media/jackpot.567329db1830c172f8bee5a36adbef5a.svg";
export { ForwardRef as ReactComponent };